package com.zaurh.portfolio.ui.theme

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.darkColorScheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.runtime.Composable

private val DarkColorScheme = darkColorScheme(
    surface = ThemeColors.Night.surface,
    background = ThemeColors.Night.background,
    primary = ThemeColors.Night.text,
    tertiary = ThemeColors.Night.neon,
    tertiaryContainer = ThemeColors.Night.textField
)

private val LightColorScheme = lightColorScheme(
    surface = ThemeColors.Day.surface,
    background = ThemeColors.Day.background,
    primary = ThemeColors.Day.text,
    tertiary = ThemeColors.Day.neon,
    tertiaryContainer = ThemeColors.Day.textField
)

@Composable
fun PortfolioTheme(
    darkTheme: Boolean = isSystemInDarkTheme(),
    content: @Composable () -> Unit
) {
    MaterialTheme(
        colorScheme = if (darkTheme) DarkColorScheme else LightColorScheme,
        typography = Typography,
        content = content
    )
}